/**
 * Animate (count) number values when scrolled into view
 * @param {obj} -obj html element to animate text value of (ie. <span>)
 * @param {int} - start value to animate from (ie. 0)
 * @param {int} - end value to animate to (this is the actual value)
 * @param {int} - animation duration in time
 * @param {mixed} - decimalSeperated, default is false, otherwise int value of value after decimal place
 *
 * @returns {void}
 */
const countNum = (obj) => {
  const animateValue = (
    obj,
    start,
    end,
    duration,
    decimalSeperated = false
  ) => {
    let startTimestamp = null;
    // This is a faff. Decimal seperated values (ie. 7.56) will be wrapped in 2x spans, each needing to have the numerical value animated
    let obj2 = obj.children[1];
    // Number values will be span wrapped for animation. ie. "145bn" will be "<span>145</span>bn"
    obj = obj.getElementsByTagName("span")[0];

    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      if (obj) {
        obj.innerText = Math.floor(progress * (end - start) + start);
      }
      if (obj2 && decimalSeperated) {
        obj2.innerText = Math.floor(
          progress * (decimalSeperated - start) + start
        );
      }
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }; // end animateValue

  const getNumberValue = (elem) => {
    let numberValue = elem.getAttribute("data-num");
    return numberValue;
  };
  // Note: this will strip out decimal places
  const formatNumberValue = (numValue) => {
    return numValue.replace(/[^0-9]/g, "");
  };

  let num = getNumberValue(obj);
  num = formatNumberValue(num);
  // wrap the number in a span. We only want to animate "33" not "33%"
  let numvalue = obj.innerText;
  var numUnformatted = getNumberValue(obj);

  if (numUnformatted.indexOf(".") !== -1) {
    // replace numbers either side of decimal place in <span> tags
    let numSplit = numUnformatted.split(".");

    // Wrap each number either side of the decimal in a span
    numSplit[0] = numSplit[0].replace(new RegExp(/\d+/), "<span>$&</span>.");
    numSplit[1] = numSplit[1].replace(new RegExp(/\d+/), "<span>$&</span>");

    // Now put it back on the page
    obj.innerHTML = numSplit[0] + numSplit[1];

    // We just need each int for the start/end values
    let digits = /\d+/;
    let numSplit1 = numSplit[0].match(digits);
    let numSplit2 = numSplit[1].match(digits);

    animateValue(obj, 0, numSplit1[0], 500, numSplit2[0]);
  } else {
    let numwrapped = numvalue.replace(num, "<span>" + num + "</span>");
    obj.innerHTML = numwrapped;
    animateValue(obj, 0, num, 500);
  }
};

const intersectionOptions = {
  threshold: 1,
  rootMargin: "0px 0px 0px 0px", // ie. "60px 0px 0px 0px"
};

var intersectionHandler = function (entries, observer) {
  entries.forEach((entry) => {
    entry.target.classList.toggle("-in-view", entry.isIntersecting);
    if (entry.isIntersecting) {
      countNum(entry.target);
      observer.unobserve(entry.target);
    }
  });
};
let observer = new IntersectionObserver(
  intersectionHandler,
  intersectionOptions
);

const numsToAnimate = Array.from(document.querySelectorAll(".js-anim-num"));

numsToAnimate.forEach((i) => {
  if (i) {
    observer.observe(i);
  }
});
